import { GET,POST } from "./api.js";
export const download = {

    excel: ( data, ) => POST(`/download-excel`, data),
    zip: ( data) => POST(`/download-zip`, data)
}